var _path, _circle;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgImage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15 2.5H5C3.61929 2.5 2.5 3.61929 2.5 5V15C2.5 16.3807 3.61929 17.5 5 17.5H15C16.3807 17.5 17.5 16.3807 17.5 15V5C17.5 3.61929 16.3807 2.5 15 2.5ZM5 4.16667H15C15.4602 4.16667 15.8333 4.53976 15.8333 5V11.9667L13.1667 9.69167C12.3146 8.99055 11.0854 8.99055 10.2333 9.69167L4.16667 14.75V5C4.16667 4.53976 4.53976 4.16667 5 4.16667ZM5.46672 15.8333H15C15.4603 15.8333 15.8334 15.4602 15.8334 15V14.1667L12.075 10.9667C11.845 10.7958 11.5301 10.7958 11.3 10.9667L5.46672 15.8333Z",
    fill: "#2E2B63"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 6.66699,
    cy: 10.4165,
    r: 1.25,
    fill: "#2E2B63"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImage);
export default __webpack_public_path__ + "static/media/image.25d612fc14e32282dfa9001c3a6ab4df.svg";
export { ForwardRef as ReactComponent };